import { useState, useEffect, useCallback, useRef } from "react";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as PayTypeIc } from "../../assets/svg/payment_ty_ic.svg";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import { ReactComponent as PurchaseIc } from "../../assets/svg/purcahse_ic.svg";
import { ReactComponent as CashIc } from "../../assets/svg/cash_ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { ReactComponent as LoadingIc } from "../../assets/svg/loading_icon.svg";
import { Dropdown, Toast, ToastContainer, Button, Modal, Form } from "react-bootstrap";
import { apiCall } from "../../services/api-service.js";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";
import LoaderModal from "../common/loader";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { format } from "date-fns";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import {
  deletePoApi,
  getPurchaseListApi,
  updateStatusApi,
} from "./purchase-api.js";
import { useGlobal } from "../../GlobalContext.js";
import numberFormat from "../common/number-format";
import {
  downloadTemplateExcelApi,
  uploadExcelApi,
} from "../transaction/transaction_api.js";

import ImportTemplateButtons from "../common/import-download-button.js";

function PurchaseListingPage() {
  // location
  const navigate = useNavigate();
  const { state } = useLocation();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  // variable initial
  const fileInputRef = useRef(null);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [selectedPayStatus, setSelectedPayStatus] = useState({
    value: "",
    label: "All",
  });
  const [selectedPOStatus, setSelectedPOStatus] = useState({
    value: "",
    label: "All",
  });
  const [active, setActive] = useState("list");
  const [selectedApprovalFilter, setSelectedApprovalFilter] = useState({
    value: "",
    label: "Show all",
  });
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [vendorSelect, setVendorSelect] = useState(null);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [purchaseList, setPurchaseList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isApprovalDropdownOpen, setIsApprovalDropdownOpen] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalPoId, setApprovalPoId] = useState(null);
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] = useState(false);

  const handleApprovalActionClick = (poId, action, isCommentsMandatory) => {
    setApprovalPoId(poId);
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(isCommentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    setIsLoading(true);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: approvalPoId,
        document_type: "purchase_order",
        action: approvalAction,
        comments: approvalComments,
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getpurchaseList();
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  const [importLoading, setImportLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);
  // Constants
  const sortByOption = [
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];
  const poStatusList = [
    {
      value: "",
      label: "All",
    },
    {
      value: "Draft",
      label: "Draft",
    },
    { value: "Confirmed", label: "Confirmed" },
    { value: "Cancelled", label: "Cancelled" },
  ];
  const payStatusList = [
    {
      value: "",
      label: "All",
    },
    {
      value: "Pending",
      label: "Pending",
    },
    { value: "Partially-Paid", label: "Partially-Paid" },
    { value: "Paid", label: "Paid" },
  ];
  const stageListOption = [
    { value: "Cancelled", label: "Cancelled" },
    { value: "Confirmed", label: "Confirmed" },
  ];

  // handle
  const handleSelectVendor = (option) => {
    console.log("Selected option:", option);
    setVendorSelect(option);
  };

  const handleClearVendor = () => {
    setVendorSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  const { rolePermissionList } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  // useEffect
  useEffect(() => {
    if (state?.status) {
      setSelectedPOStatus({
        value: state.status,
        label: state.status,
      });
    }
  }, [state]);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search), 500);
    return () => clearTimeout(timer);
  }, [search]);
  useEffect(() => {
    getpurchaseList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    itemsPerPage,
    itemOffset,
    debouncedSearch,
    selectedSortby,
    vendorSelect,
    selectedPOStatus,
    selectedPayStatus,
    startDateSave,
    endDateSave,
    selectedApprovalFilter,
  ]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const handleFileChange = async (event, responseMsg) => {
    const file = event.target.files?.[0];

    if (!file) {
      alert("Please select a valid excel file.");
      return;
    }

    setImportLoading(true);

    try {
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject("File reading failed");

        reader.readAsDataURL(file);
      });

      // ✅ WAIT for upload to finish
      await uploadExcel(base64String, responseMsg);
    } catch (error) {
      console.error(error);
      alert("Failed to import file");
    } finally {
      // ✅ Always reset input & loader
      if (event.target) {
        event.target.value = "";
      }
      setImportLoading(false);
    }
  };

  const uploadExcel = async (base64String) => {
    try {
      const response = await uploadExcelApi(
        "purchase_order_upload",
        base64String,
      );
      if (response.status === 200) {
        if (response.data.success === true) {
          const base64String = response.data.base64;
          const fileName =
            response.data.file_name ??
            `PurchaseOrder_${new Date().getTime()}.xlsx`;

          downloadBase64File(base64String, fileName);
          getpurchaseList();
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          return;
        }
      }
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.base64 != null && response.data.base64 !== "") {
        const base64String = response.data.base64;
        const fileName = `PurchaseOrder_${new Date().getTime()}.xlsx`;
        downloadBase64File(base64String, fileName);
      }
    } catch (error) {
      console.error("Error uploading Excel:", error);
      setSnackbarMessage("Error uploading file");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };
  // Api
  const updateStatus = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      const response = await updateStatusApi(id, bodyData);
      console.log("response....1", response);
      if (response.success === true) {
        getpurchaseList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deletePoApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getpurchaseList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getpurchaseList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: debouncedSearch,
      vendor_id: vendorSelect?.value ?? "",
      po_status: selectedPOStatus?.value ?? "",
      payment_status: selectedPayStatus?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
      my_approvals: selectedApprovalFilter?.value ?? "",
    };
    try {
      const response = await getPurchaseListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setPendingApprovalsCount(Number(response.data.pending_approvals_count) || 0);
        const orders = (Array.isArray(response.data.orders) ? response.data.orders : []).filter(Boolean);
        orders.forEach((order) => {
          if (order.symbol) {
            order.symbol = decodeHtml(order.symbol);
          }
        });
        setPurchaseList(orders);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadTemplateExcel = async () => {
    setTemplateLoading(true); // ✅ start loader

    try {
      const response = await downloadTemplateExcelApi("PurchaseOrder");

      if (response?.status === 200 && response?.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();

        const base64String = response.data.base64;
        const fileName = `PurchaseOrder_template_${Date.now()}.xlsx`;

        downloadBase64File(base64String, fileName);
      } else {
        throw new Error("Template download failed");
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage(error.response.data.message);
      setSnackbarStatus(error.response.data.success);
      handleSnackbarShow();
    } finally {
      setTemplateLoading(false);
    }
  };

  const downloadBase64File = (base64String, filename) => {
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"purchase"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Purchase Order" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="Purchase Order" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
                {/* Left: Heading & Search */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  <div className="my-heading fs-24 fw-600">
                    Purchase Order - {totalCount}
                  </div>

                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Right: Controls */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  {/* Add New Vendor */}
                  {checkPermission("Purchase Order", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => {
                        navigate("/po/create");
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                      </div>
                      <div className="fs-12 fw-600">New order</div>
                    </div>
                  )}
                  <ImportTemplateButtons
                    ImportIcon={ImportIc}
                    DownloadIcon={DownloadIc}
                    templateLoading={templateLoading}
                    importLoading={importLoading}
                    onImport={(e) => handleFileChange(e)}
                    onDownloadTemplate={downloadTemplateExcel}
                  />
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedPOStatus.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">
                          PO status :
                        </span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedPOStatus.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {poStatusList.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              // e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedPOStatus(option); // Execute your selection logic
                            }}
                            active={selectedPOStatus.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedPayStatus.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">
                          Payment status :
                        </span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedPayStatus.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {payStatusList.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              // e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedPayStatus(option); // Execute your selection logic
                            }}
                            active={selectedPayStatus.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_vendor`}
                      placeholder="Vendor"
                      value={vendorSelect}
                      onSelect={handleSelectVendor}
                      handleClear={handleClearVendor}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span
                      className="dropdown-text1 textPurple mb-2"
                      style={{ height: "28px" }}
                    >
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-3" style={{ marginLeft: "auto" }}>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown onToggle={(isOpen) => setIsApprovalDropdownOpen(isOpen)}>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-approval-filter"
                        className="d-flex align-items-center justify-content-between filter-btn-highlight my-approvals-toggle-btn"
                      >
                        <span className="dropdown-text">
                          {selectedApprovalFilter.label}
                        </span>

                        {pendingApprovalsCount > 0 && !isApprovalDropdownOpen && (
                          <span
                            className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              fontSize: "10px",
                              width: "16px",
                              height: "16px",
                              fontWeight: "700",
                            }}
                          >
                            {pendingApprovalsCount}
                          </span>
                        )}

                        <span className="dropdown-toggle-arrow textPurple ps-1">
                          <DownArrow />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Dropdown.Item
                          className="custom-dropdown-item"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "",
                              label: "Show all",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === ""}
                        >
                          Show all
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="custom-dropdown-item d-flex align-items-center justify-content-between"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "true",
                              label: "My approvals",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === "true"}
                          style={{ gap: "10px" }}
                        >
                          <span>My approvals</span>
                          {pendingApprovalsCount > 0 && (
                            <span
                              className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                fontSize: "10px",
                                width: "16px",
                                height: "16px",
                                fontWeight: "700",
                              }}
                            >
                              {pendingApprovalsCount}
                            </span>
                          )}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="view-toggle-container">
                    <div
                      onClick={() => setActive("list")}
                      className={`view-toggle-item ${
                        active === "list" ? "active-item" : ""
                      }`}
                    >
                      {active === "list" ? (
                        <ListView style={iconStyle} />
                      ) : (
                        <SelectList style={iconStyle} />
                      )}
                    </div>

                    <div
                      onClick={() => setActive("grid")}
                      className={`view-toggle-item ${
                        active === "grid" ? "active-item" : ""
                      }`}
                    >
                      {active === "grid" ? (
                        <SelectGrid style={iconStyle} />
                      ) : (
                        <EmailView style={iconStyle} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3 custom-scrollbar-x">
                <div style={{ minWidth: "1200px", width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    flex: "10",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#F2F2F2",
                  }}
                  className="head3 w-100 justify-content-center align-items-center"
                >
                  <p
                    style={{ flex: "1.8", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Order No
                  </p>
                  <p
                    style={{ flex: "2.0", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Vendor
                  </p>
                  <p
                    style={{ flex: "1.4", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Payment Type
                  </p>{" "}
                  <p
                    style={{ flex: "1.8", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Payment Status
                  </p>{" "}
                  <p
                    style={{ flex: "1.4", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Amount
                  </p>{" "}
                  <p
                    style={{ flex: "1.2", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Status
                  </p>{" "}
                  <p
                    style={{ flex: "2.2", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Next Approval
                  </p>{" "}
                </div>
                <div>
                  {purchaseList && purchaseList.length > 0 ? purchaseList.map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",

                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                      }}
                      onClick={() => {
                        if (
                          checkPermission("Purchase Order", "view_permission")
                        ) {
                          navigate("/po/view", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.order_no}
                      >
                        {item.order_no ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.0",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.vendor_name}
                      >
                        {item.vendor_name ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.4",
                          display: "flex",
                          alignItems: "center", // vertically align the pill itself
                          justifyContent: "flex-start", // or center, depending on layout
                        }}
                        title={item.payment_type}
                      >
                        <div
                          className="px-3"
                          style={{
                            display: "flex", // make inner a flexbox
                            alignItems: "center", // vertical center
                            justifyContent: "center", // horizontal center
                            gap: "6px", // spacing between icon & text
                            height: 24,
                            backgroundColor: "#E6E4FF",
                            borderRadius: "100px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <PayTypeIc /> {item.payment_type ?? "---"}
                        </div>
                      </div>

                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.payment_status}
                      >
                        {item.payment_status ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.4",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={numberFormat(item.amount)}
                      >
                        {item.symbol || "₹"} {numberFormat(item.amount ?? "0")}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.po_status}
                      >
                        {item.po_status ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.2",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "8px",
                          overflow: "visible",
                          minWidth: 0,
                        }}
                      >
                        {item.next_approver && item.next_approver !== "---" ? (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              backgroundColor: "#F8F9FA",
                              borderRadius: "100px",
                              padding: "4px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                            <span
                              className="text-truncate fs-13 fw-500"
                              style={{ 
                                maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100px",
                                fontStyle: "italic",
                                color: "#1E293B"
                              }}
                              title={item.next_approver}
                            >
                              {item.next_approver}
                            </span>
                          </div>
                        ) : (
                          <span
                            className="text-truncate"
                            style={{ maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100%" }}
                            title={item.next_approver}
                          >
                            {item.next_approver ?? "---"}
                          </span>
                        )}
                        {item.is_eligible && hoveredIndex === index && (
                          <>
                            <Button
                              variant="success"
                              className="rounded-5 fs-12 fw-600 py-0 px-2"
                              style={{
                                backgroundColor: "#10B981",
                                borderColor: "#10B981",
                                height: "28px",
                                lineHeight: "28px",
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleApprovalActionClick(item.id, "APPROVE", item.comments_mandatory);
                              }}
                            >
                              Approve
                            </Button>
                            {item.can_reject && (
                              <Button
                                variant="danger"
                                className="rounded-5 fs-12 fw-600 py-0 px-2 ms-1"
                                style={{
                                  backgroundColor: "#EF4444",
                                  borderColor: "#EF4444",
                                  height: "28px",
                                  lineHeight: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleApprovalActionClick(item.id, "REJECT", true);
                                }}
                              >
                                Reject
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                      {item.po_status === "Draft" && hoveredIndex === index && !item.is_eligible && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission(
                              "Purchase Order",
                              "edit_permission",
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/po/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <EditIc />{" "}
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission(
                              "Purchase Order",
                              "delete_permission",
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <DeleteIc />{" "}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )) : (
                    <div className="text-center p-4 w-100">
                      <span className="textGrey fs-14 fw-500">No Records Found</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
            {active === "grid" && (
              purchaseList && purchaseList.length > 0 ? purchaseList.map((vendor, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between flex-wrap business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer", height: "auto", minHeight: "84px" }}
                  onClick={() => {
                    if (checkPermission("Purchase Order", "view_permission")) {
                      navigate("/po/view", {
                        state: { id: vendor.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1" style={{ flex: "1 1 200px" }}>
                    <div className="profile-wrapper backgroundLitgrey">
                      <PurchaseIc />
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">
                        {vendor.order_no ?? "-"}
                      </div>
                      <div className="d-flex flex-row gap-2">
                        <div className="fs-12_5 fw-400 textGrey">
                          Payment Status :
                        </div>
                        <div className="fs-12_5 fw-500 cardTextBlue">
                          {vendor.payment_status ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 ps-3 flex-grow-1" style={{ flex: "1 1 200px" }}>
                    <div className="textltcolor fs-13 fw-400 d-flex flex-row ">
                      <div className="profile-wrapper-pur">
                        <img
                          src={
                            vendor.image && vendor.image.trim() !== ""
                              ? vendor.image
                              : profileIc
                          }
                          alt="Profile"
                          style={{ width: 24, height: 24 }}
                          className="profile-img-pur"
                        />
                      </div>
                      {"       "}
                      <div style={{ paddingLeft: "10px" }}>
                        {" "}
                        {vendor.vendor_name ?? "-"}
                      </div>
                    </div>
                    <div className="textltcolor fs-13 fw-600 d-flex flex-row">
                      <div>
                        <CashIc />
                      </div>
                      <div style={{ paddingLeft: "10px", paddingtop: "6px" }}>
                        {vendor.symbol || "₹"} {numberFormat(vendor.amount ?? "0")}
                      </div>
                      <div
                        style={{
                          width: "4px",
                          height: "4px",
                          borderRadius: "4px",
                          backgroundColor: "#D9D9D9",
                          marginLeft: "10px",
                          marginRight: "10px",
                          marginTop: "8px",
                        }}
                      ></div>
                      <div
                        className="px-3"
                        style={{
                          display: "flex", // make inner a flexbox
                          alignItems: "center", // vertical center
                          justifyContent: "center", // horizontal center
                          gap: "6px", // spacing between icon & text
                          height: 24,
                          backgroundColor: "#E6E4FF",
                          borderRadius: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {vendor.payment_type ?? "---"}
                      </div>
                    </div>
                  </div>
                  {
                    <div className="d-flex flex-row flex-grow-1 align-items-center justify-content-end gap-2 ps-3" style={{ flex: "1.2 1 300px" }}>
                      {vendor.next_approver && vendor.next_approver !== "---" && (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            backgroundColor: "#F8F9FA",
                            borderRadius: "100px",
                            padding: "4px 12px",
                            whiteSpace: "nowrap",
                            height: "36px",
                          }}
                        >
                          <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                          <span
                            className="text-truncate fs-13 fw-500"
                            style={{ 
                              maxWidth: "200px",
                              fontStyle: "italic",
                              color: "#8790A1"
                            }}
                            title={vendor.next_approver}
                          >
                            Waiting for <span style={{ color: "#1E293B", fontWeight: "600", fontStyle: "normal" }}>{vendor.next_approver}</span> approval
                          </span>
                        </div>
                      )}
                      <div className="d-flex flex-row align-items-center justify-content-end gap-2 ps-1">
                        <div onClick={(e) => e.stopPropagation()}>
                          {vendor.po_status === "Draft" ? (
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="light"
                                id="dropdown-sort"
                                className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                                style={{
                                  padding: "6px 12px",
                                }}
                              >
                                <span className="d-flex align-items-center px-1 gap-2">
                                  <span
                                    className="backgroundYellow"
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "3px",
                                      display: "inline-block",
                                    }}
                                  ></span>

                                  <span className="dropdown-text textcolor fs-13 fw-500">
                                    {vendor.po_status ?? "-"}
                                  </span>

                                  <span className="dropdown-toggle-arrow">
                                    <DownArrowIc />
                                  </span>
                                </span>
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                style={{
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  border: "1px solid #EBEBEB",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                {stageListOption.map((option) => (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    key={option}
                                    onClick={() =>
                                      updateStatus(vendor.id, option.value)
                                    }
                                  >
                                    {option.label}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : (
                            <div
                              style={{
                                padding: "6px 12px",
                                height: "36px",
                              }}
                              className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <span
                                  className="backgroundYellow"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "3px",
                                    display: "inline-block",
                                  }}
                                ></span>

                                <span className="dropdown-text textcolor fs-13 fw-500">
                                  {vendor.po_status ?? "-"}
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      {(vendor.po_status === "Draft" || vendor.is_eligible) && (
                        <div onClick={(e) => e.stopPropagation()}>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <ThreeDotIC />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {vendor.po_status === "Draft" && !vendor.is_eligible && checkPermission("Purchase Order", "edit_permission") && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/po/create", {
                                      state: { id: vendor.id },
                                    });
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              )}
                              {vendor.po_status === "Draft" && !vendor.is_eligible && checkPermission("Purchase Order", "delete_permission") && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteId(vendor.id);
                                  }}
                                >
                                  Delete
                                </Dropdown.Item>
                              )}
                              {vendor.is_eligible && (
                                <>
                                  <Dropdown.Item
                                    className="fs-14 fw-500"
                                    style={{ color: "#10B981" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleApprovalActionClick(vendor.id, "APPROVE", vendor.comments_mandatory);
                                    }}
                                  >
                                    Approve
                                  </Dropdown.Item>
                                  {vendor.can_reject && (
                                    <Dropdown.Item
                                      className="fs-14 fw-500 text-danger"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleApprovalActionClick(vendor.id, "REJECT", true);
                                      }}
                                    >
                                      Reject
                                    </Dropdown.Item>
                                  )}
                                </>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                      {vendor.po_status !== "Draft" && !vendor.is_eligible && (
                        <div style={{ width: "36px", height: "36px" }}></div>
                      )}
                    </div>
                  }
                </div>
              )) : (
                <div className="text-center p-4 w-100">
                  <span className="textGrey fs-14 fw-500">No Records Found</span>
                </div>
              )
            )}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT" ? "Reject Order" : "Approve Order"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT" 
                ? "Enter reason for rejection" 
                : "Enter comments"
              }
              {approvalCommentsMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
            style={approvalAction !== "REJECT" ? { backgroundColor: "#2563EB", borderColor: "#2563EB" } : {}}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default PurchaseListingPage;
